// Translation: Verification > Landing > Form (German)
export default Object.freeze({
	form: {
		actions: {
			verifyAccount: ''
		},
		fields: {
			code: {
				placeholder: ''
			}
		},
		options: {
			resendCode: {
				label: {
					idle: '',
					success: ''
				}
			}
		},
		title: ''
	}
})
